import React from "react";
import FileItem from "./FileItem";

export default function ResourceFiles({ resourceFiles }) {
  if (!resourceFiles || resourceFiles.length === 0) {
    return <div>No files uploaded.</div>;
  }
  return (
    <div>
      {resourceFiles.map((file, idx) => (
        <FileItem key={file._id || file.filename || idx} file={file} />
      ))}
    </div>
  );
}
